export default __webpack_public_path__ + "static/media/f399e2e7994a6886959f5181b242eded1598724535706.1fbefda2.webp";